import produce from 'immer';
import { Action } from './FMImagesActions';
import * as constants from './FMImagesConstants';

export enum IconType {
    geoPoint = 'geopoint',
    object = 'object',
}

export interface IconData {
    id: string;
    name: string;
}

export interface State {
    icons: Record<string, IconData[]>;
}

const imagesInitialState: State = {
    icons: {
        [IconType.geoPoint]: [],
        [IconType.object]: [],
    },
};

export default (state = imagesInitialState, action: Action): State =>
    produce(state, draftState => {
        switch (action.type) {
            case constants.REPLACE_ICONS_DATA: {
                const { iconsType, iconsData } = action;
                draftState.icons[iconsType] = iconsData;
                break;
            }
        }
    });
